module.exports = __webpack_public_path__ + "static/4.2_Trainingset_NO-f88ef65152295e924b7b915ea1339ada.svg";